<template>
  <v-date-picker
    v-model="model"
    :attributes="attrs"
    :min-date="minDate"
    :disabled-dates="{ weekdays: [1, 7] }"
    mode="single"
    :is-inline="true"/>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    value: {
      type: String,
      required: false,
      default: null
    }
  },
  data: () => ({
    model: null,
    minDate: null,
    attrs: [{
      key: 'today',
      highlight: {
        color: 'red',
        backgroundColor: 'red'
      },
      contentStyle: {
        color: '#fff'
      }
    }]
  }),
  watch: {
    model (date) {
      this.$emit('input', moment(date).format('YYYY-MM-DD h:mm:ss'))
    }
  },
  created () {
    this.model = moment(this.value).format('YYYY-MM-DD h:mm:ss')
    this.minDate = moment().add(1, 'day').toDate()
  }
}
</script>
